import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

import { I18nProvider } from './context/I18nContext';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import CookieBanner from './components/CookieBanner';

import Home from './pages/Home';
import Catalog from './pages/Catalog';
import WatchDetail from './pages/WatchDetail';
import About from './pages/About';
import SellWatch from './pages/SellWatch';
import Contact from './pages/Contact';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutCancel from './pages/CheckoutCancel';
import CheckoutPay from './pages/CheckoutPay';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import TermsConditions from './pages/TermsConditions';

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Toaster
              position="top-center"
              toastOptions={{
                style: { background: '#05150f', color: '#f5f5f0', border: '1px solid rgba(201, 169, 97, 0.4)', borderRadius: 0, fontFamily: 'Outfit, sans-serif' },
              }}
            />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/catalog" element={<Catalog />} />
                <Route path="/watch/:id" element={<WatchDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/sell" element={<SellWatch />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/checkout/:id" element={<CheckoutPay />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/checkout/cancel" element={<CheckoutCancel />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="/terms-conditions" element={<TermsConditions />} />
              </Routes>
            </Layout>
            <CookieBanner />
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
